import { Box, Button, Typography } from "@material-ui/core";
import React from "react";

// Single reusable component for rendering item lists
const ItemsList = ({ translate, palletsIds = [], boxesCount, title }) => {
	if (palletsIds.length === 0) return null;

	const boxesInsidePallets = boxesCount ?? 0;

	return (
		<Box sx={{ mb: 2 }}>
			{title && (
				<Typography variant="subtitle2">
					{translate(title, {
						pallets: palletsIds.length,
						boxes: boxesCount,
					})}
					:
				</Typography>
			)}
			<Box component="ul" sx={{ pl: 2, m: 0 }}>
				{palletsIds.map((id) => (
					<Typography component="li" key={`pallet-${id}`} variant="body2" sx={{ mb: 0.5 }}>
						{translate("tab.picking_list.pallet_id")} {id}
					</Typography>
				))}
			</Box>
			{boxesInsidePallets > 0 && (
				<Typography
					variant="caption"
					color="textSecondary"
					sx={{ display: "block", pl: 2, fontStyle: "italic" }}
				>
					{translate("tab.picking_list.boxes_inside_pallets_hint", {
						count: boxesInsidePallets,
					})}
				</Typography>
			)}
		</Box>
	);
};

// Action buttons component
const ActionButtons = ({ translate, handleClose, handleConfirmUnreserve, isSubmitting }) => (
	<Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
		<Button variant="outlined" onClick={handleClose} disabled={isSubmitting}>
			{translate("osfc.buttons.cancel")}
		</Button>
		<Button
			variant="contained"
			color="primary"
			onClick={handleConfirmUnreserve}
			disabled={isSubmitting}
		>
			{translate("osfc.buttons.approve")}
		</Button>
	</Box>
);

// Main warning dialog content component
export const WarningReservationActionsDialogContent = ({
	translate,
	unreservedPalletsIds = [],
	reservedPalletsIds = [],
	reservedBoxesTotal,
	unreservedBoxesTotal,
	handleClose,
	handleConfirmUnreserve,
	isSubmitting = false,
}) => {
	const hasUnreservedItems = unreservedPalletsIds.length > 0;
	const hasReservedItems = reservedPalletsIds.length > 0;
	const hasBothActions = hasUnreservedItems && hasReservedItems;

	return (
		<Box sx={{ width: 400, p: 3 }}>
			{/* Single warning message for simple cases */}
			{!hasBothActions && hasUnreservedItems && (
				<Typography variant="body1" sx={{ mb: 2, color: "text.primary" }}>
					{translate("tab.picking_list.unreserving_warning", {
						pallets: unreservedPalletsIds.length,
						boxes: unreservedBoxesTotal,
					})}
				</Typography>
			)}

			{!hasBothActions && hasReservedItems && (
				<Typography variant="body1" sx={{ mb: 2, color: "text.primary" }}>
					{translate("tab.picking_list.reserving_warning", {
						pallets: reservedPalletsIds.length,
						boxes: reservedBoxesTotal,
					})}
				</Typography>
			)}

			{/* Unreserved items section */}
			<ItemsList
				translate={translate}
				palletsIds={unreservedPalletsIds}
				boxesCount={unreservedBoxesTotal}
				title={hasBothActions ? "tab.picking_list.unreserving_warning" : null}
			/>

			{/* Reserved items section */}
			<ItemsList
				translate={translate}
				palletsIds={reservedPalletsIds}
				boxesCount={reservedBoxesTotal}
				title={hasBothActions ? "tab.picking_list.reserving_warning" : null}
			/>

			<ActionButtons
				translate={translate}
				handleClose={handleClose}
				handleConfirmUnreserve={handleConfirmUnreserve}
				isSubmitting={isSubmitting}
			/>
		</Box>
	);
};
